import { useEffect, useState } from 'react';
import { supabase } from '../supabaseClient';
import { CheckSquare, Calendar, Clock, AlertCircle } from 'lucide-react';

export default function TasksPage() {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadData();
  }, []);

  async function loadData() {
    const { data, error } = await supabase
      .from('tasks')
      .select('*')
      .order('created_at', { ascending: false });
    
    if (error) console.error('Erreur:', error);
    else setData(data);
    setLoading(false);
  }

  const getStatusColor = (status) => {
    switch(status) {
      case 'à_faire': return 'bg-red-500/20 text-red-400';
      case 'en_cours': return 'bg-yellow-500/20 text-yellow-400';
      case 'terminé': return 'bg-green-500/20 text-green-400';
      default: return 'bg-gray-500/20 text-gray-400';
    }
  };

  const getPriorityIcon = (priority) => {
    switch(priority) {
      case 'haute': return <AlertCircle size={16} className="text-red-400" />;
      case 'moyenne': return <AlertCircle size={16} className="text-yellow-400" />;
      default: return <AlertCircle size={16} className="text-gray-400" />;
    }
  };

  return (
    <div className="p-6">
      <h2 className="text-2xl font-bold mb-6 text-cyan-400 flex items-center gap-2">
        <CheckSquare size={24} />
        Tâches ({data.length})
      </h2>
      
      {loading ? (
        <p className="text-gray-400">Chargement...</p>
      ) : (
        <div className="grid grid-cols-1 gap-3">
          {data.map(task => (
            <div key={task.id} className="bg-gray-900 rounded-xl border border-gray-800 p-4 hover:border-cyan-500/50 transition">
              <div className="flex items-start justify-between">
                <div className="flex-1">
                  <div className="flex items-center gap-2 mb-1">
                    {getPriorityIcon(task.priority)}
                    <h3 className="text-white font-medium">{task.title}</h3>
                    <span className={`px-2 py-0.5 rounded-full text-xs ${getStatusColor(task.status)}`}>
                      {task.status}
                    </span>
                  </div>
                  <p className="text-gray-400 text-sm">{task.description}</p>
                  <div className="flex items-center gap-4 mt-2 text-xs text-gray-500">
                    {task.due_date && (
                      <span className="flex items-center gap-1">
                        <Calendar size={12} />
                        Échéance: {new Date(task.due_date).toLocaleDateString()}
                      </span>
                    )}
                    <span className="flex items-center gap-1">
                      <Clock size={12} />
                      Créée: {new Date(task.created_at).toLocaleDateString()}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}